var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{staticStyle:{"border-top":"none"}},[_c('a-spin',{attrs:{"spinning":_vm.isLoading}},[_c('select-input',{staticClass:"mt-0",attrs:{"setup":{
        'func': _vm.modelSetter,
        'args': {
          'model': this,
          'key': 'currentUtm',
          'options': _vm.utms,
          'prefix': 'users_report_'
        }
      }}}),(_vm.stat)?_c('div',[_c('div',{staticClass:"flex md:flex-row flex-col gap-2 mb-2"},[_c('div',{staticClass:"flex flex-col items-center md:pl-4"},[_c('span',{staticClass:"mb-2 font-bold"},[_vm._v(" "+_vm._s(_vm.$t('users_report_statistics_lang'))+" ")]),_c('pie-chart',{key:("lang-" + _vm.chartTemplate),attrs:{"data":_vm.langChartData,"options":{
              chart: {
                width: 200,
                height: 200,
                legend: true,
                innerRadius: 30,
                legendDataPercent: true,
              },
              colors: [
                'rgba(var(--a-primary), 0.8)',
                'rgba(var(--a-danger), 0.8)',
                'rgba(var(--a-warning), 0.8)',
                'rgba(var(--a-success), 0.8)' ]
            }}})],1),_c('div',{style:({ minHeight: _vm.isMobile() ? '100%' : 'auto' })},[_c('a-divider',{class:_vm.isMobile() ? 'my-2' : 'mx-2 h-full',attrs:{"type":_vm.isMobile() ? 'horizontal' : 'vertical'}})],1),_c('div',{staticClass:"flex flex-col justify-around",staticStyle:{"flex-grow":"1"}},[(_vm.stat)?_c('ratio',{key:("avatar-" + _vm.chartTemplate),staticClass:"mx-2 md:mb-0 mb-3",attrs:{"data":{
              series: [
                {
                  name: _vm.$t('users_report_statistics_has_avatar').toString(),
                  data: _vm.stat.avatar.has,
                  color: 'var(--a-success)',
                },
                {
                  name: _vm.$t('users_report_statistics_no_avatar').toString(),
                  data: _vm.stat.avatar.no,
                  color: 'var(--a-warning)',
                }
              ]
            }}}):_vm._e(),(_vm.stat)?_c('ratio',{key:("gender-" + _vm.chartTemplate),staticClass:"mx-2",attrs:{"data":{
              series: [
                {
                  name: _vm.$t('users_report_statistics_male').toString(),
                  data: _vm.stat.gender.male,
                  color: 'var(--a-primary)',
                },
                {
                  name: _vm.$t('users_report_statistics_female').toString(),
                  data: _vm.stat.gender.female,
                  color: 'var(--a-danger)',
                }
              ]
            }}}):_vm._e()],1)]),_c('div',{staticClass:"flex flex-col mb-2"},[_c('p',{staticClass:"mb-4 text-2xl font-bold text-center"},[_vm._v(" "+_vm._s(_vm.$t('users_report_statistics_bot_state'))+" ")]),_c('div',{staticClass:"flex mb-4 gap-2 justify-around md:flex-row flex-col"},_vm._l((Object.entries(_vm.stat.botState)),function(ref){
            var field = ref[0];
            var value = ref[1];
return _c('stat-value-card',{key:field,attrs:{"field-key":field,"icon":_vm.getIcon(field),"value":value}})}),1)]),_c('a-divider',{staticClass:"mb-4"}),_c('div',{staticClass:"flex flex-col"},[_c('p',{staticClass:"mb-4 text-2xl font-bold text-center"},[_vm._v(" "+_vm._s(_vm.$t('users_report_statistics_bot_state_last_month'))+" ")]),_c('div',{staticClass:"flex mb-4 gap-2 justify-around md:flex-row flex-col"},_vm._l((Object.entries(_vm.stat.lastMonth)),function(ref){
            var field = ref[0];
            var value = ref[1];
return _c('stat-value-card',{key:field,attrs:{"field-key":field,"icon":_vm.getIcon(field),"value":value}})}),1)])],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }